const DEV_API_URL = "http://localhost:4001";
const PROD_API_URL = "https://geslub-service-2licfeyhca-tl.a.run.app";

export const API_URL =
  import.meta.env.VITE_API_URL || (import.meta.env.DEV ? DEV_API_URL : PROD_API_URL);
